export default __webpack_public_path__ + "static/media/assembly_3.2bbd528d.png";